export default (bonus: number = 50) => ({
    add: 'Add',
    allOrders: 'All orders',
    orderAvailable: 'Use Drag and Drop on the numbers to select your order',
    associate: 'Associate',
    base: 'Base',
    bet: 'Bet',
    betTypeDisabled: 'Coming soon...',
    betAmount: 'Bet amount',
    chooseHorses: 'Choose my horses',
    combined: 'Combined',
    finish: 'Finish',
    identicalBets: 'Your bets must be identical',
    imminent: 'Imminent',
    invalidBet: 'Invalid bet',
    mySelection: 'My selection',
    noHorseSelected: 'No horse selected',
    notRegisteredYet: 'Not registered yet?',
    odd: 'Odds',
    partWheel: 'Part wheel',
    placeBet: 'Place',
    prepareBet: 'Prepare my bet',
    selectedBet: 'Selected bet',
    signUp: 'Sign up (up to 250€ bonus)',
    stake: 'Stake',
    totalBet: 'Total bet',
    totalWheel: 'Wheel',
    unavailable: 'Unavailable',
    unit: 'Unit',
    validateOn: 'Validate on',
    winBet: 'Win',
    smsBetConditions:
        'To participate by SMS on multiple runners in Simple, all your bets must be identical and all your paris must be winners, placed or both.',
    warning: 'Warning',
    pmuAccountRequired: 'To use this feature, you need a PMU+ account',
    pmuShortAccountRequired: 'You need a PMU+ account to validate your bets',
    pmuAccountCreated: 'I already have an account',
    createAccountAndGetBonus: `I don't have an account ${bonus} euros bonus`,
    createShortAccountAndGetBonus: `Create an account (up to ${bonus}€ bonus)`,
    dontAskAgain: "Don't ask me again",
    close: 'Close',
    playBySms: 'Play by SMS',
    missingBase: 'Please select at least one base'
})
